export default "__VITE_PUBLIC_ASSET__a8ccdb5a__"